<template>
    <div>
      <MdTitle v-bind:Text="$t('dcs.dpOfChildren')"/>
      <b-row class="mx-1">
        <b-col lg="3" md="3" sm="12">         
            <MdSelect
            v-bind:Label="$t('dcs.month')"
            v-bind:Options="MonthList"
            v-bind:ModelArray="MonthModel"
            v-bind:FieldDescription="'name'"
            v-bind:FieldCode="'code'"
            v-bind:Multiple="false"            
            :Input="ChangeDropDownMonth"/>
            <b-badge variant="danger" v-if="inputMonthError != ''">{{ inputMonthError }}</b-badge>
          </b-col>

          <b-col lg="3" md="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('dcs.year')"
                v-bind:TypeProp="'text'" 
                v-bind:Name="'Year'"
                v-model="YearModel"
                v-on:blur="OnBlurYear"               
            >                                     
            </MdEdit>
            <b-badge variant="danger" v-if="inputYearError != ''">{{ inputYearError }}</b-badge>
          </b-col>

<!--           <b-col lg="3" md="3" sm="12">         
            <MdSelect
            v-bind:Label="$t('dcs.mode')"
            v-bind:Options="ModeList"
            v-bind:Model="ModeModel"
            v-bind:FieldDescription="'name'"
            v-bind:FieldCode="'code'"
            v-bind:AllowEmpty="false"
            v-bind:Multiple="false"             
            :Input="ChangeDropDownMode"/>
            <b-badge variant="danger" v-if="inputModeError != ''">{{ inputModeError }}</b-badge>
          </b-col>
 -->
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
            v-bind:Label="$t('dcs.sortOpt')"
            v-bind:Options="SortList"
            v-bind:ModelArray="SortModel"
            v-bind:FieldDescription="'name'"
            v-bind:FieldCode="'code'"
            v-bind:Multiple="false"             
            :Input="ChangeDropDownSort"/>
          </b-col>

          <b-col lg="3" md="3" sm="12">         
            <button 
            v-on:click="populateTableNotes"
            type="button"
            class="btn btn-primary btn-login mt-3 pull-right"												
            id="btnsearchinput">
            {{ $t('Shared.Search') }}
          </button>
          </b-col>

       </b-row>
       <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
      <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
        <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
          <div class="tab-pane fade show active" id="contentNotes" role="tabpanel">
            <div class="row">
              <div class="col-md-12">
                <div class="flex-container">
                    <div class="row">                
                    
                    <div class="col-md-3">
                      <MdCheckBox
                        v-bind:Label="$t('Shared.SelectAll')"
                        v-bind:Name="'SelectTableAll'"
                        v-bind:ClassProp="'AlignCheck mx-3'"
                        v-bind:CheckedValue="true"
                        v-bind:isReadOnly="this.itemsNotes.length === 0"
                        v-bind:UncheckedValue="false"
                        v-model="UseSelectTableNotesAll" 
                        v-on:change="onChangeNotesSelectAll"                
                    /> 
                    </div>
                    <div class="col-md-3 mt-3">
                      <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedNotesRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedNotesRecords != 1">s</span> {{ $t('claimbatchList.selected') }}</span>
                    </div>  
                  <div class="col-md-6">
                            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group">
                                <input 
                                  type="text" 
                                  class="form-control"
                                  v-model="modelNotesSearch"                          
                                  @keyup.enter="FindinNotesItems()"
                                >
                                <div class="input-group-append">
                                    <MdButton 
                                      v-bind:Name="'btnsearchinput'"
                                      v-bind:VariantProp="'btn btn-sm search-attached'"
                                      v-bind:IconClass="'mdi mdi-magnify'"                               
                                      v-on:click="FindinNotesItems"
                                      >
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                  </div>               
                  </div>
                </div>
                <MdTablePaginationClient 
                  v-bind:fields="FieldsNotes"
                  v-bind:items="itemsNotes"
                  v-bind:totalRows="totalRowsNotes"
                  v-bind:showMessageIsEmpty="ShowMessageNotesIsEmpty"
                  v-bind:currentPage="currentPageNotes"
                  v-bind:perPage="perPageNotes"
                  v-bind:pageOptions="pageOptionsNotes"
                  :onFiltered="onFilteredNotes"
                  :pageChanged="pageChangedNotes" 
                  :RowClick="RowNotesClicked"
                  :perPageFunction="PerPageFunctionNotes"
                  :onRowSelected="onRowSelectedNotes"
                  v-bind:SelectAll="UseSelectTableNotesAll">
                </MdTablePaginationClient>
              </div>
            </div>        
          </div>
          <div class="tab-pane fade" id="contentReview" role="tabpanel">

            <div id="alert" v-if="reviewResult && reviewResult.systemErrors || reviewResult.errorList && reviewResult.errorList.length > 0" class="alert alert-fill-warning mx-3" role="alert">
              <i class="mdi mdi-alert"></i>
              <b>We found errors!</b> Please, check them out before proceeding.
            </div>

            <div class="zebraAccordion" v-if="reviewResult && reviewResult.systemErrors || reviewResult.errorList && reviewResult.errorList.length > 0">
              <div class="zebraRow"> 
    
                <div class="accordion" role="tablist" >              
                    <div class="zebraItem" v-b-toggle="'accordion-1'">
                        <div class="container-fluid">
                          <div class="row">                      
                            <i class="ikon med-dropdown mr-2"></i> <b>Error Found During Export Review</b>
                          </div>
                        </div>
                    </div>
                    <b-card no-body>                
                      <b-collapse :id="'accordion-1'" accordion="my-accordion" role="tabpanel">
                        <b-card-body class="accordionContent"> 
                                          <br>
                                          <MdTitle v-bind:Text="'System Errors'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-if="reviewResult && reviewResult.systemErrors"/>
                                          <!--<div data-label="Error Messages" class="textlabel pt-3 pb-0"></div>-->

                                          <MdMemo v-if="reviewResult && reviewResult.systemErrors"
                                            v-bind:Name="'dcsErrortextarea_description'"
                                            v-bind:Rows="'10'"
                                            v-bind:MaxRows="'10'" 
                                            class="mt-2"          
                                            v-model="ErrorReview"
                                            v-bind:isReadOnly="true"                                            
                                          />  

                                          <MdTitle v-bind:Text="$t('dcs.ErrorsByPatient')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-if="reviewResult.errorList && reviewResult.errorList.length > 0"/>
                                          <b-row v-if="reviewResult.errorList && reviewResult.errorList.length > 0">
                                              <div class="col-md-6 offset-md-6">
                                                  <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                                                      <div class="input-group">
                                                          <input 
                                                            type="text" 
                                                            class="form-control"
                                                            v-model="modelReviewErrorsSearch"
                                                            @keyup.enter="FindinReviewErrorsItems()"
                                                          >
                                                          <div class="input-group-append">
                                                              <MdButton 
                                                                v-bind:Name="'btnsearchinput'"
                                                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                                                v-bind:IconClass="'mdi mdi-magnify'"
                                                                v-on:click="FindinReviewErrorsItems()">
                                                              </MdButton>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div> 
                                          </b-row> 
                                          <div v-if="reviewResult.errorList && reviewResult.errorList.length > 0">
                                            <div class="col-md-12">
                                              <MdTablePaginationClient 
                                                v-bind:fields="fieldsReviewError"
                                                v-bind:items="itemsReviewError"
                                                v-bind:totalRows="totalRowsReviewError"
                                                v-bind:showMessageIsEmpty="ShowMessageIsEmptyReviewError"
                                                v-bind:currentPage="currentPageReviewError"
                                                v-bind:perPage="perPageReviewError"
                                                v-bind:pageOptions="pageOptionsReviewError"
                                                :onFiltered="onFilteredReviewError"
                                                :pageChanged="pageChangedReviewError" 
                                                :perPageFunction="PerPageFunctionReviewError"
                                                :onRowSelected="onRowSelectedReviewError"
                                                v-bind:FieldsDate="FieldsDateReviewErrorArr"
                                                :RowClick="RowReviewErrorClicked">
                                              </MdTablePaginationClient>
                                            </div>
                                          </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>         
                  </div>
              </div>
            </div>

           <MdTitle v-bind:Text="ReviewSummary" 
               v-bind:VisibleDownload="true" 
              @ClickDownload="DownloadReview" 
              v-bind:ReadOnlyDownload="ReadOnlyReviewActions" 

              v-bind:VisibleEmail="true" 
              @ClickEmail="SendEmailReview" 
              v-bind:ReadOnlyEmail="ReadOnlyReviewActions" 

              class="mt-5"
              v-bind:isSubtitle="true" 
              v-bind:Name="'T_TitleSearch'"/>
            <div class="row mx-1" v-if="itemsReview && itemsReview.length > 0 || isFindingItems">
              <div class="col-md-12">
                <div class="flex-container">
                    <div class="row">                
                  <div class="col-md-6 offset-md-6">
                            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group">
                                <input 
                                  type="text" 
                                  class="form-control"
                                  v-model="modelReviewSearch"                          
                                  @keyup.enter="FindinReviewItems()"
                                >
                                <div class="input-group-append">
                                    <MdButton 
                                      v-bind:Name="'btnsearchinput'"
                                      v-bind:VariantProp="'btn btn-sm search-attached'"
                                      v-bind:IconClass="'mdi mdi-magnify'"                               
                                      v-on:click="FindinReviewItems"
                                      >
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                  </div>               
                  </div>
                </div>
                <MdTablePaginationClient 
                  v-bind:fields="FieldsReview"
                  v-bind:items="itemsReview"
                  v-bind:totalRows="totalRowsReview"
                  v-bind:showMessageIsEmpty="ShowMessageReviewIsEmpty"
                  v-bind:currentPage="currentPageReview"
                  v-bind:perPage="perPageReview"
                  v-bind:pageOptions="pageOptionsReview"
                  :onFiltered="onFilteredReview"
                  :pageChanged="pageChangedReview" 
                  :RowClick="RowReviewClicked"
                  :perPageFunction="PerPageFunctionReview"
                  :onRowSelected="onRowSelectedReview"
                  v-bind:SelectAll="UseSelectTableReviewAll">
                </MdTablePaginationClient>
                
              </div>
            </div>
            <div v-else>
                <div v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
                    <div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div>
                </div>
            </div>
          </div>
          <div class="tab-pane fade" id="contentProduction" role="tabpanel">

            <div id="alert" v-if="productionResult && productionResult.errorMessages || productionResult.systemErrors || productionResult.errorList && productionResult.errorList.length > 0" class="alert alert-fill-warning mx-3" role="alert" >
              <i class="mdi mdi-alert"></i>
              <b>We found errors!</b> Please, check them out before proceeding.
            </div>
            
            <div class="zebraAccordion" v-if="productionResult && productionResult.errorMessages || productionResult.systemErrors || productionResult.errorList && productionResult.errorList.length > 0">
              <div class="zebraRow"> 
    
                <div class="accordion" role="tablist" >              
                    <div class="zebraItem" v-b-toggle="'accordion-2'">
                        <div class="container-fluid">
                        <div class="row">                      
                          <i class="ikon med-dropdown mr-2"></i> <b>Error Found During Export Production</b>
                        </div>
                        </div>

                    </div>
                    <b-card no-body>                 
                      <b-collapse :id="'accordion-2'" accordion="my-accordion2" role="tabpanel">
                        <b-card-body class="accordionContent"> 
                                          <br>
                                          <MdTitle v-bind:Text="'Error Messages'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-if="productionResult && productionResult.errorMessages"/>
                                          <!--<div data-label="Error Messages" class="textlabel pt-3 pb-0"></div>-->
                                          <MdMemo v-if="productionResult && productionResult.errorMessages"
                                            v-bind:Name="'dcsProductionerrorMessages'"
                                            v-bind:Rows="'10'"
                                            v-bind:MaxRows="'10'" 
                                            v-model="errorMessagesProduction"
                                            v-bind:isReadOnly="true"                                            
                                          />
                                          <MdTitle v-bind:Text="'System Errors'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-if="productionResult && productionResult.systemErrors"/>
                                          <!--<div data-label="System Errors" class="textlabel mt-3 pb-0"></div>-->
                                          <MdMemo v-if="productionResult && productionResult.systemErrors"
                                          v-bind:Name="'dcsProductionsystemErrors'"
                                          v-bind:Rows="'10'"
                                          v-bind:MaxRows="'10'" 
                                          v-model="systemErrorsProduction"
                                          v-bind:isReadOnly="true"                                            
                                        />

                                          <MdTitle v-bind:Text="$t('dcs.ErrorsByPatient')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-if="productionResult.errorList && productionResult.errorList.length > 0"/>
                                          <b-row v-if="productionResult.errorList && productionResult.errorList.length > 0">
                                              <div class="col-md-6 offset-md-6">
                                                  <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                                                      <div class="input-group">
                                                          <input 
                                                            type="text" 
                                                            class="form-control"
                                                            v-model="modelProductionErrorsSearch"
                                                            @keyup.enter="FindinProductionErrorsItems()"
                                                          >
                                                          <div class="input-group-append">
                                                              <MdButton 
                                                                v-bind:Name="'btnsearchinput'"
                                                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                                                v-bind:IconClass="'mdi mdi-magnify'"
                                                                v-on:click="FindinProductionErrorsItems()">
                                                              </MdButton>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div> 
                                          </b-row> 
                                          <div v-if="productionResult.errorList && productionResult.errorList.length > 0">
                                            <div class="col-md-12">
                                               <MdTablePaginationClient 
                                                v-bind:fields="fieldsReviewError"
                                                v-bind:items="itemsProductionError"
                                                v-bind:totalRows="totalRowsProductionError"
                                                v-bind:showMessageIsEmpty="ShowMessageIsEmptyProductionError"
                                                v-bind:currentPage="currentPageProductionError"
                                                v-bind:perPage="perPageProductionError"
                                                v-bind:pageOptions="pageOptionsProductionError"
                                                :onFiltered="onFilteredProductionError"
                                                :pageChanged="pageChangedProductionError" 
                                                :perPageFunction="PerPageFunctionProductionError"
                                                :onRowSelected="onRowSelectedProductionError"
                                                v-bind:FieldsDate="FieldsDateReviewErrorArr"
                                                :RowClick="RowProductionErrorClicked">
                                              </MdTablePaginationClient>
                                            </div>
                                          </div>                                          
                        </b-card-body>
                      </b-collapse>
                    </b-card>         
                  </div>
              </div>
            </div>
            
           <MdTitle 
           v-bind:Text="ProductionSummary" 
           
           v-bind:VisibleDownload1="true" 
           v-bind:ReadOnlyDownload1="ReadOnlyProductionActions" 
           @ClickDownload1="DownloadProduction" 

           v-bind:VisibleEmail1="true" 
           v-bind:ReadOnlyEmail1="ReadOnlyProductionActions" 
           @ClickEmail1="SendEmailProduction" 
           
           v-bind:VisibleTrash="true" 
           v-bind:ReadOnlyTrash="ReadOnlyProductionActions" 
           @ClickTrash="DeleteProduction" 

           class="mt-5"
           
           v-bind:isSubtitle="true" 
           v-bind:Name="'T_TitleSearch'"/>

            <div class="row mx-1" v-if="itemsProduction.length > 0 || isFindingProduction">
              <div class="col-md-12">
                <div class="flex-container">
                    <div class="row">                
                    
                  <div class="col-md-6 offset-md-6">
                            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group">
                                <input 
                                  type="text" 
                                  class="form-control"
                                  v-model="modelProductionSearch"                          
                                  @keyup.enter="FindinProductionItems()"
                                >
                                <div class="input-group-append">
                                    <MdButton 
                                      v-bind:Name="'btnsearchinput'"
                                      v-bind:VariantProp="'btn btn-sm search-attached'"
                                      v-bind:IconClass="'mdi mdi-magnify'"                               
                                      v-on:click="FindinProductionItems"
                                      >
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                  </div>               
                  </div>
                </div>
                <MdTablePaginationClient 
                  v-bind:fields="FieldsProduction"
                  v-bind:items="itemsProduction"
                  v-bind:totalRows="totalRowsProduction"
                  v-bind:showMessageIsEmpty="ShowMessageProductionIsEmpty"
                  v-bind:currentPage="currentPageProduction"
                  v-bind:perPage="perPageProduction"
                  v-bind:pageOptions="pageOptionsProduction"
                  :onFiltered="onFilteredProduction"
                  :pageChanged="pageChangedProduction" 
                  :RowClick="RowProductionClicked"
                  :perPageFunction="PerPageFunctionProduction"
                  :onRowSelected="onRowSelectedProduction"
                  v-bind:SelectAll="UseSelectTableProductionAll">
                </MdTablePaginationClient>
              </div>
            </div>
            <div v-else>
                <div v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
                    <div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div>
                </div>
            </div>
          </div>
        </div>
      </MdTabList>
      
      <!-- <vue-good-wizard
        ref="wizard"
        :steps="steps"
        :finalStepLabel="''"
        :onNext="nextClicked" 
        :onBack="backClicked">
        <div slot="filter">
       
       <b-row>
          <b-col lg="6" md="6" sm="12"> 
            <MdTitle v-bind:Text="$tc('Shared.Note', 2)" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <MdCheckListBox2 
                v-model="NotesModel"
                v-bind:Options="NotesList"
                v-bind:OnChangeProp="OnChangeNotes"
                v-bind:Height="'300px'"
                v-bind:columnCount="1"
                :textField="'name'"
                :valueField="'code'"/> 
          </b-col>    
          <b-col lg="6" md="6" sm="12"> 
            <MdTitle v-bind:Text="$t('dcs.tables')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <MdCheckListBox2 
                v-model="TablesModel"
                v-bind:Options="TablesList"
                v-bind:OnChangeProp="OnChangeTable"
                v-bind:Height="'300px'"
                v-bind:columnCount="1"
                :textField="'name'"
                :valueField="'code'"/> 
          </b-col>   
       </b-row>
        </div>
        <div slot="general">
         
        </div>
        <div slot="production">
          <b-button-group>
            <MdButton
                v-bind:Label="$t('dcs.vSpreadsheet')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="ViewDCS"
                v-bind:isReadOnly="errorSystem != '' || errorMessage != '' || disabledButton == true"
            />
            <MdButton
                v-bind:Label="$t('dcs.vExceptions')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="ViewException"
                v-if="exceptionList.length != 0"
            />
            <MdButton
                v-bind:Label="$t('dcs.dDCF')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DownloadDCS"
                v-bind:isReadOnly="errorSystem != '' || errorMessage != '' || disabledButton == true"
            />
            <MdButton
                v-bind:Label="$t('dcs.vBatchErrors')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="ViewBatchErr"
                v-if="errorMessage != '' && warningMessage != ''"
            />
          </b-button-group>
          <DxPoPupTable v-if="isVisible" 
              :Title="$t('dcs.review')"
              :closeWindow="closeRepWindow"
              :isVisible="isVisible"
              :items = "this.items"
              :ShowMessageIsEmpty="showMessageIsEmpty"
              :onRowSelected="onRowSelected"
          />
        </div>
        <div slot="review">
          <MdTitle v-bind:Text="$t('dcs.rvError')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <MdButton
              v-bind:Label="$t('dsc.vSpreadsheet')"
              v-bind:ClassProp="'secondary mx-2 btn-login'"
              v-on:click="ViewDCS"
              v-bind:isReadOnly="errorSystem != '' || errorMessage != '' || disabledButton == true"
            />
            <MdButton
              v-bind:Label="$t('dsc.vExceptions')"
              v-bind:ClassProp="'secondary mx-2 btn-login'"
              v-on:click="ViewException"
              v-if="exceptionList.length != 0"
            />
            <MdButton
                v-bind:Label="$t('dcs.dDCF')"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DownloadDCS"
                v-bind:isReadOnly="errorSystem != '' || errorMessage != '' || disabledButton == true"
            />
            <DxPoPupTable v-if="isVisible" 
              :Title="$tc('dcs.review')"
              :closeWindow="closeRepWindow"
              :isVisible="isVisible"
              :items = "this.items"
              :fields = "this.fields"
              :ShowMessageIsEmpty="showMessageIsEmpty"
              :onRowSelected="onRowSelected"
            />
        </div>
      </vue-good-wizard> -->
      <b-modal ref="progress-modal" size="md" hide-footer :title="$t('dsc.vSpreadsheet')">
        <MdProgress
          v-bind:ShowProgress="true"
          :value="progressVal"
          v-bind:Max="100"
          v-bind:Label="label"
        />
      </b-modal>
      <b-modal ref="batch-modal" size="md" hide-footer title="Claim Batch Error">
        <div class="d-block text-center">
          <h5 v-if="errorMessage != ''">{{$tc('dsc.error')}}: {{ errorMessage }}</h5>
          <h5 v-if="warningMessage != ''">{{$t('dsc.warnings')}}: {{ warningMessage }}</h5>
          <div class="text-center my-2" v-if="errorMessage == '' && warningMessage == ''">
            <b-badge pill variant="light" style="font-size: medium;">{{$t('dsc.nErrorWarmsg')}}</b-badge>
          </div>
        </div>
      </b-modal>

      <MdPasswordDlg v-if="showSignPassword" 
      v-bind:Type="TypePassWord"
      v-bind:VerificationType="'SupervisorPassword'"
      @getModalPassword="onModalPasswordResult($event)"
    />

      <div class="space-actions"></div>
      <div class="page-actions">
        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="GotoDcsList"
          />

        <MdButton
        v-bind:Label="$t('dcs.review')"
        v-bind:isReadOnly="DisabledBtn()"
        v-bind:ClassProp="'secondary mx-2 btn-login'"
        v-on:click="DoReview()"
      />
      <MdButton
      v-bind:Label="$t('dcs.production')"
      v-bind:isReadOnly="DisabledBtn()"
      v-bind:ClassProp="'secondary mx-2 btn-login'"
      v-on:click="DoProduction()"
    />
        
        <!--<b-dropdown id="dropdown-dropup" :disabled="SelectedNotesRecords == 0 ? true : false" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">
          <b-dropdown-item href="#" v-if="SelectedNotesRecords > 0" v-on:click="DoReview()" >Do Review</b-dropdown-item>
          <b-dropdown-item href="#" v-if="SelectedNotesRecords > 0" v-on:click="DoProduction()" >Do Production</b-dropdown-item>                
        </b-dropdown>-->
      </div>

      <ModalSendMail
        v-bind:TitleWindow="'Send by E-Mail'"
        @ModalClickOk="SendEmail"  
        v-bind:ModalId="modalSendMail"
        v-bind:Subject="conformSubject">
      </ModalSendMail>

      <b-modal size="md" :hide-header-close="true" cancel-variant="primary" :cancel-title="$t('rClinicalNotes.DOWNLOAD')" :ok-title="modalButtonLabel" :ok-only="buttonOK" :no-close-on-backdrop="true" :no-close-on-esc="true" scrollable centered title="Processing" :visible="showModalProgress" @ok="emitEventOK" @hide="emitEventHide" @cancel="emitEventCancel">
      <div v-if="showProgressBar" id="ContainerProgress">
        <MdProgress
          v-bind:Label="progressLabel"
          v-bind:Max="maxValue"
          v-bind:ShowProgress="false"
          v-bind:ShowValue="false"
          v-model="progressValue"
          v-bind:valueErr="ProgressValueErr"                 
        />
        <div v-if="progressLabel2" class="row">
          <small class="col-12">
            {{progressLabel2}}
          </small>
        </div>
        
      </div>
      </b-modal>

  </div>
</template>
  
  <script>
  import DCSService from '../../../services/dcs.service';
  import ShowMessage from '@/components/messages/ShowMessage.js';
  import DBFunctions from '@/common/DBFunctions.js';
  import * as CSV from 'csv-string';
  import { EventBus } from '@/event-bus.js';
  import Utils from '@/common/utils'

  export default {
    mixins: [ShowMessage, DBFunctions],
    name: 'DCS',
    data(){
      return {
        pageOptionsReviewError:[5, 10, 15 ],
        perPageReviewError:10,
        currentPageReviewError:1,
        ShowMessageIsEmptyReviewError:true,
        totalRowsReviewError:0,
        itemsReviewError:[],

        pageOptionsProductionError:[5, 10, 15 ],
        perPageProductionError:10,
        currentPageProductionError:1,
        ShowMessageIsEmptyProductionError:true,
        totalRowsProductionError:0,
        itemsProductionError:[],

         fieldsReviewError:[
         { key: 'description', sortable: true, label: 'Description', class: 'text-rigth' }, 
         { key: 'patientCode', sortable: true, label: 'Patient Code', class: 'text-rigth' },
          { key: 'patientName', sortable: true, label: 'Patient Name', class: 'text-rigth' },
          { key: 'headerID', sortable: true, label: 'Header ID', class: 'text-rigth hidden' },
          { key: 'contactDate', sortable: true, label: 'Contact Date', class: 'text-rigth' },
          { key: 'activity', sortable: true, label: 'Activity', class: 'text-rigth' },
          { key: 'recID', sortable: true, label: 'RecID', class: 'text-rigth hidden' },          
          { key: 'startTime', sortable: true, label: 'Start Time', class: 'text-rigth' },
          { key: 'endTime', sortable: true, label: 'End Time', class: 'text-rigth' },          
          { key: 'duration', sortable: true, label: 'Duration', class: 'text-rigth' },
          { key: 'recordId', sortable: true, label: 'RecordID', class: 'text-rigth hidden' },          
          { key: 'groupCreationID', sortable: true, label: 'Group Creation ID', class: 'text-rigth hidden' },
          { key: 'version', sortable: true, label: 'Version', class: 'text-rigth hidden' },
          { key: 'dateFrom', sortable: true, label: 'Date From', class: 'text-rigth hidden' },
          { key: 'dateTo', sortable: true, label: 'Date To', class: 'text-rigth hidden' },
        ],
        FieldsDateReviewErrorArr: ['contactDate'],

        errorMessagesProduction:"",
        systemErrorsProduction:"",

        MonthModel:{},
        productionVersion:"",
        ErrorReview:"",
        
        ReadOnlyReviewActions:true,
        ReadOnlyProductionActions:true,

        productionGroupCreationId:"",
        year:"",
        month:"",
        ProductionSummary:this.$t('dcs.ProductionExport'),
        ReviewSummary:this.$t('dcs.ReviewExport'),
        ModeModel:{
          "name":"Review",
          "code":1
        },
        SortModel:{
          "name":"Invoice Number, Service Date",
          "code":2
        },        
        YearModel: new Date().getFullYear(),
        NotesModel:[],
        showSignPassword: false,
        TypePassWord:'Sign',
        TablesModel:[],
        perPage: 10,
        currentPage: 1,
        items:[],
        fields:[],
        SelectedPage : 0,
        totalRows: 0,
        MonthList:[
            {name: this.$t('Layout.dMonth.January'),code:1},
            {name: this.$t('Layout.dMonth.February'),code:2},
            {name: this.$t('Layout.dMonth.March'),code:3},
            {name: this.$t('Layout.dMonth.April'),code:4},
            {name: this.$t('Layout.dMonth.May'),code:5},
            {name: this.$t('Layout.dMonth.June'),code:6},
            {name: this.$t('Layout.dMonth.July'),code:7},
            {name: this.$t('Layout.dMonth.August'),code:8},
            {name: this.$t('Layout.dMonth.September'),code:9},
            {name: this.$t('Layout.dMonth.October'),code:10},
            {name: this.$t('Layout.dMonth.November'),code:11},
            {name: this.$t('Layout.dMonth.December'),code:12},
        ],
        ModeList:[
            {name:this.$t('dcs.review'),code:1},
            {name:this.$t('dcs.production'),code:2}
        ],
        SortList:[
          {name:"Therapy, Patient, Service Date", code:0},
          {name:"Patient, Service Date, Therapy", code:1},
          {name:"Invoice Number, Service Date", code:2}
        ],
        NotesList:[],
        TablesList:[],
        TempTable:[],
        pageOptions: [5, 10, 15 ],
        steps: [
          {
            label: this.$t('dcs.filters'),
            slot: 'filter',
          },
          {
            label: this.$t('dcs.review'),
            slot: 'general',
          },
          {
            label: this.$t('dcs.production'),
            slot: 'review',
          }
        ],
        noteKeys: [],
        tableKeys: [],
        datasheet: [],
        tableControlList: [],
        errorSystem: "",
        url: "",
        fileName:"",
        isVisible: false,
        errorMessage: "",
        warningMessage: "",
        inputMonthError: '',
        inputYearError: '',
        inputModeError: '',
        disabledButton: false,
        exceptionList: [],
        downloadfile: [],
        version: '',
        showProgress: false,
        progressVal: 0,
        interval: '',
        label: "",
        tableError: false,
        ComparedTable: [],
        TempTableModel: [],
        showMessageIsEmpty: false,

        tablist: [
            {id:1, title: 'Notes', link: '#contentNotes',href:"contentNotes", active: true},
            {id:2, title: this.$t('dcs.review'), link: '#contentReview',href:"contentReview", active:false},
            {id:3, title: this.$t('dcs.production'), link: '#contentProduction',href:"contentProduction",active:false},
        ],
        FieldsNotes:[
          { key: 'formTitle', sortable: true, label: 'Notes'},
          { key: 'tableName', sortable: true, label: 'Table Name'},
          { key: 'controlID', sortable: false, class:'hidden', label: 'Title'},
        ],
        itemsNotes: [],
        totalRowsNotes: 0,
        ShowMessageNotesIsEmpty: true,
        currentPageNotes: 1,
        perPageNotes: 10,
        pageOptionsNotes: [5, 10, 15 ],
        UseSelectTableNotesAll: false,
        SelectedNotesRecords: 0,
        modelNotesSearch: "",
        CopyNotesItems:[],
        
        FieldsReview:[
          { key: 'email_Address', sortable: true, label: 'Email'},
          { key: 'phone_Number', sortable: true, label: 'Phone'},
          { key: 'vendor_ID', sortable: true, label: 'Vendor ID'},
          { key: 'vendor_Location', sortable: true, label: 'Vendor Location'},
          { key: 'vendor_Address_Seq', sortable: true, label: 'Vendor Address Seq'},
          { key: 'invoice_Type', sortable: true, label: 'Invoice Type'},
          { key: 'bill_Type', sortable: true, label: 'Bill Type'},
          { key: 'patientcode', sortable: true, label: 'Patient Code'},
          { key: 'patientName', sortable: true, label: 'Patient Name'},
          { key: 'progCode', sortable: true, label: 'Program Code'},
          { key: 'invoice_Number', sortable: true, label: 'Invoice Number'},
          { key: 'invoice_Date', sortable: true, label: 'Invoice Date'},
          { key: 'service_Type', sortable: true, label: 'Service Type'},
          { key: 'billable_Unit_ID', sortable: true, label: 'Billable Unit ID'},
          { key: 'person_ID', sortable: true, label: 'Person ID'},
          { key: 'case_ID', sortable: true, label: 'Case ID'},
          { key: 'billing_Code', sortable: true, label: 'Billing Code'},
          { key: 'service_Desc', sortable: true, label: 'Service Description'},
          { key: 'service_Code', sortable: true, label: 'Service Code'},
          { key: 'component_Code', sortable: true, label: 'Component Code'},
          { key: 'start_Date', sortable: true, label: 'Start Date'},
          { key: 'end_Date', sortable: true, label: 'End Date'},
          { key: 'units', sortable: true, label: 'Units'},
          { key: 'uom', sortable: true, label: 'UOM'},
          { key: 'rate', sortable: true, label: 'Rate'},
          { key: 'amount', sortable: true, label: 'Amount'},
          { key: 'county_Code', sortable: true, label: 'County Code'},
          { key: 'comments', sortable: true, label: 'Comments'},
          { key: 'place_of_Service', sortable: true, label: 'Place of Service'},
          { key: 'mdrC_1', sortable: true, label: 'MDRC_1'},
          { key: 'mdrC_2', sortable: true, label: 'MDRC_2'},
          { key: 'mdrC_3', sortable: true, label: 'MDRC_3'},
          { key: 'mdrC_4', sortable: true, label: 'MDRC_4'},
          { key: 'mdrC_5', sortable: true, label: 'MDRC_5'},
          { key: 'title', sortable: true, label: 'Title'},
          { key: 'type', sortable: true, label: 'Type'},
          { key: 'content', sortable: true, label: 'Content'}
        ],
        itemsReview: [],
        totalRowsReview: 0,
        ShowMessageReviewIsEmpty: true,
        currentPageReview: 1,
        perPageReview: 10,
        pageOptionsReview: [5, 10, 15 ],
        UseSelectTableReviewAll: false,
        SelectedReviewRecords: 0,
        modelReviewSearch: "",
        CopyReviewItems:[],

        FieldsProduction:[
          { key: 'email_Address', sortable: true, label: 'Email'},
          { key: 'phone_Number', sortable: true, label: 'Phone'},
          { key: 'vendor_ID', sortable: true, label: 'Vendor ID'},
          { key: 'vendor_Location', sortable: true, label: 'Vendor Location'},
          { key: 'vendor_Address_Seq', sortable: true, label: 'Vendor Address Seq'},
          { key: 'invoice_Type', sortable: true, label: 'Invoice Type'},
          { key: 'bill_Type', sortable: true, label: 'Bill Type'},          
          { key: 'invoice_Number', sortable: true, label: 'Invoice Number'},
          { key: 'invoice_Date', sortable: true, label: 'Invoice Date'},
          { key: 'service_Type', sortable: true, label: 'Service Type'},
          { key: 'billable_Unit_ID', sortable: true, label: 'Billable Unit ID'},
          { key: 'person_ID', sortable: true, label: 'Person ID'},
          { key: 'case_ID', sortable: true, label: 'Case ID'},
          { key: 'billing_Code', sortable: true, label: 'Billing Code'},
          { key: 'service_Code', sortable: true, label: 'Service Code'},
          { key: 'component_Code', sortable: true, label: 'Component Code'},
          { key: 'start_Date', sortable: true, label: 'Start Date'},
          { key: 'end_Date', sortable: true, label: 'End Date'},
          { key: 'units', sortable: true, label: 'Units'},
          { key: 'uom', sortable: true, label: 'UOM'},
          { key: 'rate', sortable: true, label: 'Rate'},
          { key: 'amount', sortable: true, label: 'Amount'},
          { key: 'county_Code', sortable: true, label: 'County Code'},
          { key: 'comments', sortable: true, label: 'Comments'},
          { key: 'place_of_Service', sortable: true, label: 'Place of Service'},
          { key: 'mdrC_1', sortable: true, label: 'MDRC_1'},
          { key: 'mdrC_2', sortable: true, label: 'MDRC_2'},
          { key: 'mdrC_3', sortable: true, label: 'MDRC_3'},
          { key: 'mdrC_4', sortable: true, label: 'MDRC_4'},
          { key: 'mdrC_5', sortable: true, label: 'MDRC_5'},
          { key: 'title', sortable: true, label: 'Title'},
          { key: 'type', sortable: true, label: 'Type'},
          { key: 'content', sortable: true, label: 'Content'}
        ],
        itemsProduction: [],
        totalRowsProduction: 0,
        ShowMessageProductionIsEmpty: true,
        currentPageProduction: 1,
        perPageProduction: 10,
        pageOptionsProduction: [5, 10, 15 ],
        UseSelectTableProductionAll: false,
        SelectedProductionRecords: 0,
        modelProductionSearch: "",
        CopyProductionItems:[],
        modalSendMail: "modalSendMail",
        conformSubject: null,
        productionParams: {},
        modalButtonLabel: this.$t('Shared.BtnCancel'),
        buttonOK: true,
        showModalProgress: false,
        showProgressBar: true,
        progressLabel: '',
        progressLabel2: '',
        maxValue: 100,
        progressValue: 100,
        ProgressValueErr: 0,
        timer: null,
        sec: 0,
        min: 0,
        hour: 0,
        SearchCriteria:'',
        reviewParams: {},
        productionResult: {},
        reviewResult: {},
        CopyReviewErrorsItems: [],
        modelReviewErrorsSearch: '',
        CopyProductionErrorsItems: [],
        modelProductionErrorsSearch: '',
        emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },
        isFindingItems: false,
        isFindingProduction: false,
        cancelProgress: false
      };
    },
    methods: {

      FindinReviewErrorsItems(){     
        this.itemsReviewError = this.CopyReviewErrorsItems;
          var arr = this.itemsReviewError;
          var temp = [];
          if(this.modelReviewErrorsSearch){
          arr.forEach(element => {
            if(element.description && element.description.toUpperCase().includes(this.modelReviewErrorsSearch.toUpperCase()) || element.patientCode && element.patientCode.toUpperCase().includes(this.modelReviewErrorsSearch.toUpperCase())            
            || element.patientName && element.patientName.toUpperCase().includes(this.modelReviewErrorsSearch.toUpperCase()) || element.contactDate && element.contactDate.toUpperCase().includes(this.modelReviewErrorsSearch.toUpperCase()) 
            || element.activity && element.activity.toUpperCase().includes(this.modelReviewErrorsSearch.toUpperCase()) || element.startTime && element.startTime.toUpperCase().includes(this.modelReviewErrorsSearch.toUpperCase())           
            || element.endTime && element.endTime.toUpperCase().includes(this.modelReviewErrorsSearch.toUpperCase()) || element.duration && element.duration.toString().includes(this.modelReviewErrorsSearch.toUpperCase()) 
            ){
                temp.push(element);
            }
          });
          }else{
            temp = this.CopyReviewErrorsItems;
          }      
          this.itemsReviewError = temp;
          this.totalRowsReviewError = temp.length;
      },

      FindinProductionErrorsItems(){     
        this.itemsProductionError = this.CopyProductionErrorsItems;
          var arr = this.itemsProductionError;
          var temp = [];
          if(this.modelProductionErrorsSearch){
          arr.forEach(element => {
            if(element.description && element.description.toUpperCase().includes(this.modelProductionErrorsSearch.toUpperCase()) || element.patientCode && element.patientCode.toUpperCase().includes(this.modelProductionErrorsSearch.toUpperCase())            
            || element.patientName && element.patientName.toUpperCase().includes(this.modelProductionErrorsSearch.toUpperCase()) || element.contactDate && element.contactDate.toUpperCase().includes(this.modelProductionErrorsSearch.toUpperCase()) 
            || element.activity && element.activity.toUpperCase().includes(this.modelProductionErrorsSearch.toUpperCase()) || element.startTime && element.startTime.toUpperCase().includes(this.modelProductionErrorsSearch.toUpperCase())           
            || element.endTime && element.endTime.toUpperCase().includes(this.modelProductionErrorsSearch.toUpperCase()) || element.duration && element.duration.toString().includes(this.modelProductionErrorsSearch.toUpperCase()) 
            ){
                temp.push(element);
            }
          });
          }else{
            temp = this.CopyProductionErrorsItems;
          }      
          this.itemsProductionError = temp;
          this.totalRowsProductionError = temp.length;
      },

      emitEventOK() {
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.showModalProgress = false
      },

      emitEventHide() {
        this.showModalProgress = false
        this.cancelProgress = true
      },

      emitEventCancel() {
        //this.stopProgress(this.$t('rClinicalNotes.Canceled'))
        this.cancelProgress = true
      },

      Actions(){

      },

      PerPageFunctionReviewError(){

      },

      pageChangedReviewError(page){
        this.currentPageReviewError = page
      },

      onFilteredReviewError(){

      },

      onRowSelectedReviewError(){

      },

      PerPageFunctionProductionError(){

      },

      pageChangedProductionError(page){
        this.currentPageProductionError = page
      },

      onFilteredProductionError(){

      },

      onRowSelectedProductionError(){

      },

      DisabledBtn(){
        let count = 0;
        for(var i = 0; i < this.itemsNotes.length; i++){
          if(this.itemsNotes[i].selected){
            count++;
          }
        }

        return count === 0;
      },


      ActiveTab(tabid){
        this.tablist.forEach(element => {
          element.active = false;
          if(element.id === tabid){
            element.active = true;
          }
        });
      },

      SetTabContent(tabid){      
       for(var i = 0; i < this.tablist.length; i++){
        if(this.tablist[i].id === tabid){      
          document.getElementById(this.tablist[i].href).classList = "tab-pane fade active show";          
        }else{
          document.getElementById(this.tablist[i].href).classList = "tab-pane fade";
          document.getElementById(this.tablist[i].href).classList = "tab-pane fade";
        }
       }       
      },

      DownloadReview(){
        var baseurl = this.$store.state.apiurl.replace('/api/', '');
         if(this.url) {
          this.FullUrl = baseurl+this.url;
          this.DownloadUrl(this.FullUrl,this.fileName); 
         }
      },

      async SendEmail(To, Cc, Subject, Body) {  
        this.$emit('load', true)
        let baseurl = this.$store.state.apiurl.replace('/api/', '');
        let params = {
            to: To,
            cc: Cc ? Cc : null,
            subject: Subject,
            body: Body ? Body : null,
            attachmentUrl: this.url ? baseurl+this.url : null,
            groupCreationID: this.productionGroupCreationId ? this.productionGroupCreationId : null,
            version: this.productionVersion ? this.productionVersion.toString() : null
        }
        await DCSService.dcseMail(params).then(response => {
          let resp = response

          if (resp.data.success == true)
            this.showMessage('DCS by e-mail','The e-mail was sent')
          else 
            this.showMessage('DCS by e-mail',resp.data.errorMessage,"error");

          this.$emit('load', false);
        }).catch(error => {
          this.$emit('load', false);
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
        this.$emit('load', false) 
      },

      SendEmailReview(){
        this.$bvModal.show(this.modalSendMail);
      },

      SendEmailProduction(){
        this.$bvModal.show(this.modalSendMail);
      },

      DownloadProduction(){
        this.Download();
      },

      onModalPasswordResult(result){      
          if(result.Event === 'Ok'){   
            if(result.status === true) {   
                this.DeleteDCS({year:this.year,month:this.month,version:this.productionVersion});  
          }else{
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.InvalidSupervisorPass'),"error");
          }
        }
        this.showSignPassword = false;
    },

    async DeleteDCS(row){        
        this.$emit('load', true);  
             await DCSService.dcsDelete(row.year, row.month, row.version)
                .then(() => {                
                  this.itemsProduction = [];
                  this.productionResult = []
                  this.isFindingProduction = false
                  this.ReadOnlyProductionActions = (this.itemsProduction === null || this.itemsProduction.length === 0) ? true : false;

                  this.$emit('load', false);
                  this.showMessage(this.$t('Msg.Success'),'Record deleted!'); 
                })
                .catch((error) => {
                  this.$emit('load', false);  
                    if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }else{
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                     }                   
                });
    },


      DeleteProduction(){       
        this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$t('dcsList.pDeleteMsg'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_dcs'
				})
          .then(value => {
            if(value){
              this.showSignPassword = true;
            }else{
              this.showSignPassword = false;
            }
          })    
      },

      async DownloadUrl(url, filename) {          
           const data = await fetch(url)
           const blob = await data.blob()
           const objectUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.setAttribute('href', objectUrl)
          link.setAttribute('download', filename)
          link.style.display = 'none'
          document.body.appendChild(link)                          
          link.click()                          
          document.body.removeChild(link)
      },

     Download(){
        var baseurl = this.$store.state.apiurl.replace('/api/', '');             
        DCSService.dcsdownload(this.productionGroupCreationId,this.productionVersion)
            .then((response) => {      
               if (response.data) {
                this.FullUrl = baseurl+response.data.url;   
                this.DownloadUrl(this.FullUrl,response.data.fileName);                
               }                
         })
         .catch(error => {           
            if(error.response.status === 400 ){
                 this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            }else{
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
     },


      DoReview() {
        let listControlID = []

        for(var i = 0; i < this.itemsNotes.length; i++){
          if(this.itemsNotes[i].selected){
            listControlID.push(String(this.itemsNotes[i].controlID))
          }
        }

        if (this.SelectedNotesRecords > 0)
          this.DCSReview(listControlID)
      },

      DoProduction() {
        let listControlID = []

        for(var i = 0; i < this.itemsNotes.length; i++){
          if(this.itemsNotes[i].selected){
            listControlID.push(String(this.itemsNotes[i].controlID))
          }
        }

        if (this.SelectedNotesRecords > 0)
          this.DCSProduction(listControlID)
      },

      FindinNotesItems(){     
        this.itemsNotes = this.CopyNotesItems;
          var arr = this.itemsNotes;
          var temp = [];
          if(this.modelNotesSearch){
          arr.forEach(element => {
            if(element.formTitle && element.formTitle.toUpperCase().includes(this.modelNotesSearch.toUpperCase()) || element.tableName && element.tableName.toUpperCase().includes(this.modelNotesSearch.toUpperCase())            
            ){
                temp.push(element);
            }
          });
          }else{
            temp = this.CopyNotesItems;
          }      
          this.itemsNotes = temp;
          this.totalRowsNotes = temp.length;
      },

      FindinReviewItems(){     
        this.itemsReview = this.CopyReviewItems;
          var arr = this.itemsReview;
          var temp = [];
          if(this.modelReviewSearch){
          arr.forEach(element => {
            if(element.patientName && element.patientName.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.patientcode && element.patientcode.toUpperCase().includes(this.modelReviewSearch.toUpperCase())            
            || element.bill_Type && element.bill_Type.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.amount && element.amount.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.billable_Unit_ID && element.billable_Unit_ID.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.billing_Code && element.billing_Code.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.case_ID && element.case_ID.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.comments && element.comments.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.component_Code && element.component_Code.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.content && element.content.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.county_Code && element.county_Code.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.email_Address && element.email_Address.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.end_Date && element.end_Date.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.invoice_Date && element.invoice_Date.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.invoice_Number && element.invoice_Number.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.invoice_Type && element.invoice_Type.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.mdrC_1 && element.mdrC_1.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.mdrC_2 && element.mdrC_2.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.mdrC_3 && element.mdrC_3.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.mdrC_4 && element.mdrC_4.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.mdrC_5 && element.mdrC_5.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.person_ID && element.person_ID.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.phone_Number && element.phone_Number.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.place_of_Service && element.place_of_Service.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.progCode && element.progCode.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.rate && element.rate.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.service_Code && element.service_Code.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.service_Desc && element.service_Desc.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.service_Type && element.service_Type.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.start_Date && element.start_Date.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.title && element.title.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.type && element.type.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.units && element.units.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.uom && element.uom.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.vendor_Address_Seq && element.vendor_Address_Seq.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) || element.vendor_ID && element.vendor_ID.toUpperCase().includes(this.modelReviewSearch.toUpperCase()) 
            || element.vendor_Location && element.vendor_Location.toUpperCase().includes(this.modelReviewSearch.toUpperCase())
            ){
                temp.push(element);
            }
          });
            this.isFindingItems = true
          }else{
            temp = this.CopyReviewItems;
          }      
          this.itemsReview = temp;
          this.totalRowsReview = temp.length;
      },

      FindinProductionItems(){     
        this.itemsProduction = this.CopyProductionItems;
          var arr = this.itemsProduction;
          var temp = [];
          if(this.modelProductionSearch){
          arr.forEach(element => {
            if(element.bill_Type && element.bill_Type.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.amount && element.amount.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.billable_Unit_ID && element.billable_Unit_ID.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.billing_Code && element.billing_Code.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.case_ID && element.case_ID.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.comments && element.comments.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.component_Code && element.component_Code.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.content && element.content.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.county_Code && element.county_Code.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.email_Address && element.email_Address.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.end_Date && element.end_Date.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.invoice_Date && element.invoice_Date.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.invoice_Number && element.invoice_Number.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.invoice_Type && element.invoice_Type.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.mdrC_1 && element.mdrC_1.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.mdrC_2 && element.mdrC_2.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.mdrC_3 && element.mdrC_3.toUpperCase().includes(this.modelRevimodelProductionSearchewSearch.toUpperCase()) || element.mdrC_4 && element.mdrC_4.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.mdrC_5 && element.mdrC_5.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.person_ID && element.person_ID.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.phone_Number && element.phone_Number.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.place_of_Service && element.place_of_Service.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.rate && element.rate.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.service_Code && element.service_Code.toUpperCase().includes(this.modelProductionSearch.toUpperCase())
            || element.service_Type && element.service_Type.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.start_Date && element.start_Date.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.title && element.title.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.type && element.type.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.units && element.units.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.uom && element.uom.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.vendor_Address_Seq && element.vendor_Address_Seq.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) || element.vendor_ID && element.vendor_ID.toUpperCase().includes(this.modelProductionSearch.toUpperCase()) 
            || element.vendor_Location && element.vendor_Location.toUpperCase().includes(this.modelProductionSearch.toUpperCase())
            ){
                temp.push(element);
            }
          });
             this.isFindingProduction = true
          }else{
            temp = this.CopyProductionItems;
          }      
          this.itemsProduction = temp;
          this.totalRowsProduction = temp.length;
      },

      onChangeNotesSelectAll(v){
        if(v){
          this.SelectedNotesRecords = this.itemsNotes.length; 
          for(var i = 0 ; i < this.itemsNotes.length; i++){
            this.$set(this.itemsNotes[i], 'selected', true); 
          }
        }else{
          this.SelectedNotesRecords = 0;
          for(var j= 0 ; j < this.itemsNotes.length; j++){
            this.$set(this.itemsNotes[j], 'selected', false); 
          }
        }
      },

      onChangeReviewSelectAll(v){
        if(v){
          this.SelectedReviewRecords = this.itemsReview.length; 
          for(var i = 0 ; i < this.itemsReview.length; i++){
            this.$set(this.itemsReview[i], 'selected', true); 
          }
        }else{
          this.SelectedReviewRecords = 0;
          for(var j= 0 ; j < this.itemsReview.length; j++){
            this.$set(this.itemsReview[j], 'selected', false); 
          }
        }
      },

      onChangeProductionSelectAll(v){
        if(v){
          this.SelectedProductionRecords = this.itemsProduction.length; 
          for(var i = 0 ; i < this.itemsProduction.length; i++){
            this.$set(this.itemsProduction[i], 'selected', true); 
          }
        }else{
          this.SelectedProductionRecords = 0;
          for(var j= 0 ; j < this.itemsProduction.length; j++){
            this.$set(this.itemsProduction[j], 'selected', false); 
          }
        }
      },

      onRowSelectedNotes(){
        this.SelectedNotesRecords = 0;
        if(this.itemsNotes.length > 0){
          for(var i = 0; i < this.itemsNotes.length; i++){
            if(this.itemsNotes[i].selected){
              this.SelectedNotesRecords++;
            }
          }
        }
      },

      onRowSelectedReview(){
        this.SelectedReviewRecords = 0;
        if(this.itemsReview.length > 0){
          for(var i = 0; i < this.itemsReview.length; i++){
            if(this.itemsReview[i].selected){
              this.SelectedReviewRecords++;
            }
          }
        }
      },

      onRowSelectedProduction(){
        this.SelectedProductionRecords = 0;
        if(this.itemsProduction.length > 0){
          for(var i = 0; i < this.itemsProduction.length; i++){
            if(this.itemsProduction[i].selected){
              this.SelectedProductionRecords++;
            }
          }
        }
      },

      PerPageFunctionNotes(perpage){
        this.perPageNotes = perpage;  
        this.currentPageNotes = 1;
      },

      PerPageFunctionReview(perpage){
        this.perPageReview = perpage;  
        this.currentPageReview = 1;
      },

      PerPageFunctionProduction(perpage){
        this.perPageProduction = perpage;  
        this.currentPageProduction = 1;
      },


      onFilteredNotes(){

      },

      onFilteredReview(){

      },

      onFilteredProduction(){

      },

      pageChangedNotes(page){
        this.currentPageNotes = page;   
      },

      pageChangedReview(page){
        this.currentPageReview = page;   
      },

      pageChangedProduction(page){
        this.currentPageProduction = page;   
      },

      RowNotesClicked(item){ 
        if(item.selected){      
          this.$set(item, 'selected', false);         
        }else{
          this.$set(item, 'selected', true);       
        }
        EventBus.$emit('rowNotesClicked', item);
      },

      RowReviewClicked(){ 
      },

      RowReviewErrorClicked() {
      },

      RowProductionErrorClicked() {
      },

      RowProductionClicked(){ 
    },

      populateTableNotes() {
        this.UseSelectTableNotesAll = false
        this.SelectedNotesRecords = 0

        if((this.YearModel != "") && (this.MonthModel.name != undefined) && (this.ModeModel.name != undefined)){
            this.PopulateNotes()
          }
          else {
            if(this.YearModel == ""){
              this.inputYearError = this.$t('dcs.mInMsg')
            }
            if(this.MonthModel.name == undefined) {
              this.inputMonthError = this.$t('dcs.mInMsg')
            }
            if(this.ModeModel.name == undefined){
              this.inputModeError = this.$t('dcs.mInMsg')
            }
            this.showMessage(this.$tc('Msg.Error'), this.$t('dcs.mInMsg'), "error")
            return false;
          }
      },

      nextClicked(currentPage) {
        const _this = this
        this.inputMonthError = ""
        this.inputModeError = ""
        this.inputYearError = ""
        if(currentPage == 0){
          if((_this.YearModel != "") && (_this.MonthModel.name != undefined) && (_this.ModeModel.name != undefined)){
            this.PopulateNotes()
            _this.$refs.wizard.goTo(currentPage)
          }
          else {
            if(_this.YearModel == ""){
              this.inputYearError = this.$t('dcs.mInMsg')
            }
            if(_this.MonthModel.name == undefined) {
              this.inputMonthError = this.$t('dcs.mInMsg')
            }
            if(_this.ModeModel.name == undefined){
              this.inputModeError = this.$t('dcs.mInMsg')
            }
            this.showMessage(this.$tc('Msg.Error'), this.$t('dcs.mInMsg'), "error")
            return false;
          }
        }
        
        if(currentPage == 1){
          if((_this.NotesModel.length != 0) && (_this.TablesModel.length != 0)){
            _this.$refs.wizard.goTo(currentPage)
            if(_this.ModeModel.code == 1){
              this.$refs['progress-modal'].show()
              this.showProgress = true
              this.DCSReview(_this.TablesModel).then(() => {
                this.$refs['progress-modal'].hide()
                if(this.errorSystem == ''){
                  this.ViewDCS()
                }
              })
            }
            if(_this.ModeModel.code == 2){
              this.$refs['progress-modal'].show()
              this.showProgress = true
              this.DCSProduction(_this.TablesModel).then(() => {
                this.$refs['progress-modal'].hide()
                if(this.errorSystem == ''){
                  this.ViewDCS()
                }
              })
            }
          }
          else {
            this.showMessage(this.$tc('Msg.Error'), this.$t('dcs.mInMsg'), "error")
            return false;
          }
        }
        return true
      },
      backClicked(currentPage) {
        if(currentPage == 2){
          this.TablesModel = []
          this.NotesModel = []
          this.TablesList = []
          this.progressVal = 0
        }
        if(currentPage == 1){
          this.NotesList = []
          this.TablesModel = []
          this.NotesModel = []
          this.TablesList = []
          this.tableControlList = []
        }
        return true; //return false if you want to prevent moving to previous page
      },

      ChangeDropDownMonth(month){
        if(month){
          this.MonthModel = month
        }
        this.populateTableNotes()
      },

      OnBlurYear() {
        this.populateTableNotes()
      },

      onFiltered(){

      },

      OnChangeNotes(){
        this.TablesList = this.tableControlList.filter((item) => this.NotesModel.includes(item.note))
        this.TablesModel = []
        this.TablesList.forEach(element => {
          this.TablesModel.push(element.code)
        });
        if(this.NotesModel.length == 0){
          this.TablesList = []
        }
      },

      OnChangeTable(){
        this.TempTableModel = this.TablesList.filter((item) => this.TablesModel.includes(item.code))
        this.ComparedTable = []
        this.TempTableModel.forEach(element => {
          this.ComparedTable.push(element.note)        
        });
        this.TempNoteList = this.NotesList.filter((item) => this.ComparedTable.includes(item.code))
        this.NotesModel = []
        this.TempNoteList.forEach(element => {
          this.NotesModel.push(element.code)
        });
        if(this.TablesModel.length == 0){
          this.NotesModel = []
        }
      },

      onRowSelected(){

      },

      pageChanged(){

      },

      Error(){

      },

      PerPageFunction(){

      },

      ViewException(){
        this.items = this.exceptionList
        this.isVisible = true
      },

      ViewBatchErr(){
        this.$refs['batch-modal'].show()
      },

      ViewDCS(){
        if(this.tableError == true){
          this.isVisible = false
        }
        else{
          this.items = this.datasheet
          this.isVisible = true
        }
      },

      closeRepWindow(){
        this.isVisible = false
      },

      ChangeDropDownMode(mode){
        if(mode){
           this.ModeModel = mode;
        }

        if(this.ModeModel.code === 2){
           // this.steps.pop();
           this.steps.splice(2, 1);
           this.steps.splice(2, 0, {label:this.$t('dcs.proError'),slot:"production"})
           // this.steps.push({label:"Production Errors",slot:"production"});
        }
        if(this.ModeModel.code === 1){
            //this.steps.pop();
            this.steps.splice(2, 1);
           // this.steps.push({label:"Review Errors",slot:"review"});
            this.steps.splice(2, 0, {label:this.$t('dcs.rvError'),slot:"review"})
        }
      },

      ChangeDropDownSort(sort){
        this.SortModel = sort
      },

      GotoDcsList(){
        this.checkExistFavorite('/app/dcs');
        this.$router.push({name: "dcs-list"});
      },

      async PopulateNotes(){
        this.$emit('load', true)
        let params = {
          "month": this.MonthModel.code.toString(),
          "year": this.YearModel.toString() 
        }
        await DCSService.populateNotes2(params.year,params.month).then(response => {
          this.itemsNotes = response.data
          this.CopyNotesItems = response.data
          this.totalRowsNotes = response.data.length;
          if (this.itemsNotes.length === 0) {
            this.ShowMessageNotesIsEmpty = true;                      
          }else{
            this.UseSelectTableNotesAll = true;
            this.onChangeNotesSelectAll(true);
          }
          this.itemsReview = [];
          this.itemsProduction = [];

          this.ReadOnlyProductionActions = true;
          this.ReadOnlyReviewActions= true;
         
          this.ActiveTab(1);
          document.getElementById("contentNotes").classList = "tab-pane fade active show";
          document.getElementById("contentReview").classList = "tab-pane fade";
          document.getElementById("contentProduction").classList = "tab-pane fade";

        }).catch(error => {
          this.$emit('load', false);
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
        this.$emit('load', false)
      },

      async TableControls(noteID){
        let params = {
          "month": this.MonthModel.code.toString(),
          "year": this.YearModel.toString(),
          "noteID": noteID.toString()
        }
        await DCSService.tableControl(params).then(response => {
          let tables = {}
          
          let values = JSON.parse("[" + response.data.constrolDescriptionList + "]")
          this.tableKeys = JSON.parse("[" + response.data.controlIDList.substring(response.data.controlIDList.indexOf("=") + 1) + "]")
          let noteIDs = JSON.parse("[" + response.data.controlIDList.substring(0, response.data.controlIDList.indexOf("=")) + "]")
          let newValues = []
          values.forEach(description => {
            let newDes = description.substring(description.indexOf("- ") + 1)
            newValues.push(newDes)
          });
          this.tableKeys.forEach((key, index) => {
            tables = {"code": key, "name": key + " - " + newValues[index], "note": noteIDs[index]}
            this.tableControlList.push(tables)
          })
        }).catch(error => {
          this.$emit('load', false);
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
      },

      async DCSReview(list){
        if(this.SortModel == ''){
          this.SortModel = 2
        }
        let params = {
          "month": this.MonthModel.code.toString(),
          "year": this.YearModel.toString(),
          "controlIdList": list,
          "orderByIDX": this.SortModel.code.toString()
        }
        this.$emit('load', true);  
        await DCSService.dcsReview(params).then(response => {
          this.reviewParams = response.data
          //this.startProcess('Review')
          this.cancelProgress = false
          this.ReviewResult()
          this.$emit('load', false);  
        }).catch(error => {
          this.disabledButton = true
          this.$emit('load', false);  
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
      },

     /*  async ReviewResult(){
        await DCSService.dcsReviewResult(this.reviewParams).then((response) => {
          if (response.data.finished) {
              this.stopProgress('Completed')
              this.reviewResult = response.data
              this.itemsReviewError = this.reviewResult.errorList
              this.itemsReviewError.forEach(function(element) {
                let { contactDate } = element
                if (contactDate) element.contactDate = Utils.formatterDateToString(contactDate);
              });
              this.CopyReviewErrorsItems = this.reviewResult.errorList
              this.totalRowsReviewError = this.reviewResult.errorList.length             
              this.ErrorReview = response.data.systemErrors;
              this.ActiveTab(2);          
              document.getElementById("contentReview").classList = "tab-pane fade active show";
              document.getElementById("contentProduction").classList = "tab-pane fade";
              document.getElementById("contentNotes").classList = "tab-pane fade";
              this.fileName = response.data.fileName;
              this.itemsReview = response.data.list
              this.ReadOnlyReviewActions = (this.itemsReview === null || this.itemsReview.length === 0) ? true : false;
              this.CopyReviewItems = response.data.list
              this.totalRowsReview = response.data.list.length;
              this.conformSubject = `DCS-review-${this.YearModel}${this.MonthModel.code.toString()}`

              this.ReviewSummary = (this.itemsReview !== null && this.itemsReview.length > 0) ?  
              this.$t('dcs.ReviewExport') +  " - Total Charges $"+response.data.dcsTotalCharges+" - No Transactions "+response.data.dcsTotalTrans :  this.$t('dcs.ReviewExport') ;
              this.isFindingItems = false
              if (this.itemsReview.length === 0) {
                this.ShowMessageReviewIsEmpty = true;                      
              }else{
                this.$bvToast.toast(this.$t('Msg.ExportedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                              autoHideDelay: 5000,
                              variant: "success"
                            })
              }
            }
            
        }).catch(error => {
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
      }, */


      /* async ProductionResult1(){
        await DCSService.dcsProductionResult(this.productionParams).then((response) => {
          if (response.data.finished) {
            this.stopProgress('Completed')
            this.productionResult = response.data
            this.errorMessagesProduction = this.productionResult.errorMessages
            this.systemErrorsProduction = this.productionResult.systemErrors
            this.itemsProductionError = this.productionResult.errorList
            this.itemsProductionError.forEach(function(element) {
              let { contactDate } = element
              if (contactDate) element.contactDate = Utils.formatterDateToString(contactDate);
            });
            this.CopyProductionErrorsItems = this.itemsProductionError 
            this.totalRowsProductionError = this.productionResult.errorList.length
            this.productionVersion = response.data.version,
            this.productionGroupCreationId = response.data.groupCreationId;   
            this.year = response.data.year; 
            this.month = response.data.month;           
            this.itemsProduction = response.data.list;
            this.conformSubject = `${this.productionGroupCreationId}ver${this.productionVersion.toString()}`

            this.ProductionSummary = (this.itemsProduction !== null && this.itemsProduction.length > 0) ?  
            this.$t('dcs.ProductionExport') +  " - Total Charges $"+response.data.dcsTotalCharges+" - No Transactions "+response.data.dcsTotalTrans :  this.$t('dcs.ProductionExport') ;
            this.isFindingProduction = false
            
            this.ActiveTab(3);         
            document.getElementById("contentProduction").classList = "tab-pane fade active show";
            document.getElementById("contentReview").classList = "tab-pane fade";
            document.getElementById("contentNotes").classList = "tab-pane fade";
            this.CopyProductionItems = response.data.list
            this.totalRowsProduction = response.data.list.length;
            this.ReadOnlyProductionActions = (this.itemsProduction === null || this.itemsProduction.length === 0) ? true : false;
            if (this.itemsProduction.length === 0) {
              this.ShowMessageProductionIsEmpty = true;                      
            }else{           
              this.$bvToast.toast(this.$t('Msg.ExportedSuccessfully'), {
                          title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: "success"
                          })          
            }
            }
            
        }).catch(error => {
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
      }, */

      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },


      async ReviewResult(){
        let finished = false;

        this.startProcess()
        
        while (!finished && !this.cancelProgress) {
        try {
            const response = await DCSService.dcsReviewResult(this.reviewParams)
            const data = response.data;

            this.checkMonitor()

            if (data.finished) {
              //this.stopProgress('Completed')
              this.reviewResult = response.data
              this.itemsReviewError = this.reviewResult.errorList
              this.itemsReviewError.forEach(function(element) {
                let { contactDate } = element
                if (contactDate) element.contactDate = Utils.formatterDateToString(contactDate);
              });
              this.CopyReviewErrorsItems = this.reviewResult.errorList
              this.totalRowsReviewError = this.reviewResult.errorList.length             
              this.ErrorReview = response.data.systemErrors;
              this.ActiveTab(2);          
              document.getElementById("contentReview").classList = "tab-pane fade active show";
              document.getElementById("contentProduction").classList = "tab-pane fade";
              document.getElementById("contentNotes").classList = "tab-pane fade";
              this.url = response.data.url;
              this.fileName = response.data.fileName;
              this.itemsReview = response.data.list
              this.ReadOnlyReviewActions = (this.itemsReview === null || this.itemsReview.length === 0) ? true : false;
              this.CopyReviewItems = response.data.list
              this.totalRowsReview = response.data.list.length;
              this.conformSubject = `DCS-review-${this.YearModel}${this.MonthModel.code.toString()}`

              this.ReviewSummary = (this.itemsReview !== null && this.itemsReview.length > 0) ?  
              this.$t('dcs.ReviewExport') +  " - Total Charges $"+response.data.dcsTotalCharges+" - No Transactions "+response.data.dcsTotalTrans :  this.$t('dcs.ReviewExport') ;
              this.isFindingItems = false
              if (this.itemsReview.length === 0) {
                this.ShowMessageReviewIsEmpty = true;                      
              }else{
                this.$bvToast.toast(this.$t('Msg.ExportedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                              autoHideDelay: 5000,
                              variant: "success"
                            })
              }
              this.stopProgress()
              break;
            }

            // Wait before the next request
            await this.delay(2000);
        } catch (error) {
            console.error('API call failed:', error.message);
            // Optional: break or retry depending on your strategy
            break;
          }
        }
      },

      async ProductionResult(){
        let finished = false;

        this.startProcess()
        
        while (!finished && !this.cancelProgress) {
        try {
            const response = await DCSService.dcsProductionResult(this.productionParams)
            const data = response.data;

            this.checkMonitor()

            if (data.finished) {
              this.productionResult = response.data
              this.errorMessagesProduction = this.productionResult.errorMessages
              this.systemErrorsProduction = this.productionResult.systemErrors
              this.itemsProductionError = this.productionResult.errorList
              this.itemsProductionError.forEach(function(element) {
                let { contactDate } = element
                if (contactDate) element.contactDate = Utils.formatterDateToString(contactDate);
              });
              this.CopyProductionErrorsItems = this.itemsProductionError 
              this.totalRowsProductionError = this.productionResult.errorList.length
              this.productionVersion = response.data.version,
              this.productionGroupCreationId = response.data.groupCreationId;   
              this.year = response.data.year; 
              this.month = response.data.month;           
              this.itemsProduction = response.data.list;
              this.conformSubject = `${this.productionGroupCreationId}ver${this.productionVersion.toString()}`

              this.ProductionSummary = (this.itemsProduction !== null && this.itemsProduction.length > 0) ?  
              this.$t('dcs.ProductionExport') +  " - Total Charges $"+response.data.dcsTotalCharges+" - No Transactions "+response.data.dcsTotalTrans :  this.$t('dcs.ProductionExport') ;
              this.isFindingProduction = false
              
              this.ActiveTab(3);         
              document.getElementById("contentProduction").classList = "tab-pane fade active show";
              document.getElementById("contentReview").classList = "tab-pane fade";
              document.getElementById("contentNotes").classList = "tab-pane fade";
              this.CopyProductionItems = response.data.list
              this.totalRowsProduction = response.data.list.length;
              this.ReadOnlyProductionActions = (this.itemsProduction === null || this.itemsProduction.length === 0) ? true : false;
              if (this.itemsProduction.length === 0) {
                this.ShowMessageProductionIsEmpty = true;                      
            }else{           
              this.$bvToast.toast(this.$t('Msg.ExportedSuccessfully'), {
                          title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: "success"
                          })          
            }
              this.stopProgress()
              break;
            }

            // Wait before the next request
            await this.delay(2000);
        } catch (error) {
            console.error('API call failed:', error.message);
            // Optional: break or retry depending on your strategy
            break;
          }
        }
      },

      async DCSProduction(list){
        if(this.SortModel == ''){
          this.SortModel = 2
        }
        let params = {
          "month": this.MonthModel.code.toString(),
          "year": this.YearModel.toString(),
          "controlIdList": list,
          "orderByIDX": this.SortModel.code.toString()
        }
        this.$emit('load', true);  
        await DCSService.dcsProduction(params).then((response) => {
          this.productionParams = response.data
          //this.startProcess('Production')
          this.cancelProgress = false
          this.ProductionResult()
          this.$emit('load', false);  
        }).catch(error => {
          this.$emit('load', false);
          this.disabledButton = true
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
      },

      stopProgress(msg) {
        //clearInterval(this.timer)
        this.sec = 0
        this.min = 0
        this.hour = 0
        this.progressLabel2 = msg
        this.modalButtonLabel = this.$t('Shared.Close')
        //this.progressValue = 0
        this.showModalProgress = false
      },

      async startProcess() {
        this.sec = 0
        this.min = 0
        this.hour = 0
        this.buttonOK = true
        this.progressLabel2 = ''
        this.showProgressBar = true
        this.modalButtonLabel = this.$t('Shared.BtnCancel')
        this.progressLabel = 'Processing'
        this.$emit('load', true);
        this.showModalProgress = true
        //await this.runMonitor(Param)
      },

     /*  runMonitor(Param) {
        this.timer = setInterval(()=> this.checkMonitor(Param), 2000)
      },
 */
      checkMonitor() {
        this.sec+=2
        if(this.sec >= 59){
          this.sec = 0;
          this.min++;
        }
        if(this.min >= 59){
          this.min = 0;
          this.hour++;
        }
        this.progressLabel =  `${this.$t('rClinicalNotes.tTimeElapsed')} ${this.getElapseTime(this.hour,this.min,this.sec)}`
        /* if (Param == 'Production')
          this.ProductionResult()
        else (
          this.ReviewResult()
        ) */
      },

      getElapseTime(hour,min,sec) {
        const nSec = (sec <= 9)? sec="0"+sec : sec
        const nMin = (min <= 9)? min="0"+min : min
        const nHour = (hour <= 9)? hour="0"+hour : hour
        return `${nHour}:${nMin}.${nSec}`
      },

      async DCSException(){
        this.$emit('load', true);
        let params = {
          "groupCreationID": "DCS" + this.MonthModel.code.toString() + this.YearModel.toString(),
          "mode": this.ModeModel.name,
          "version": (this.ModeModel.name == "production"? this.version : 1)
        }
        await DCSService.dcsException(params).then(response => {
          this.exceptionList = response.data
          this.$emit('load', false);
          if(this.exceptionList.length == 0){
            this.showMessageIsEmpty = true
          }
        }).catch(error => {
          this.$emit('load', false);
          this.disabledButton = true
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        })
      },

      generateTable(content){
        try{
          let rows = CSV.parse(content, {output: 'objects'})
          //rows = JSON.parse(rows)
          this.datasheet = rows
          this.downloadfile = rows
          this.items = rows
          this.items.forEach(element => {
            element.amount = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(element.amount)
          });
        }catch(error){
          this.tableError = true
          this.showMessage(this.$tc('Msg.Error'),this.$t('dcs.rExcelMsg'),"error");
        }
      },

      jsonToCsv(jsonData) {
          let csv = '';
          // Get the headers
          let headers = Object.keys(jsonData[0]);
          csv += headers.join(',') + '\n';
          // Add the data
          jsonData.forEach(function (row) {
              let data = headers.map(header => JSON.stringify(row[header])).join(','); // Add JSON.stringify statement
              csv += data + '\n';
          });
          csv = csv.replace(/\\"/g, "")
          return csv;
      },

      DownloadDCS() {
        try{
          let csv = this.jsonToCsv(this.downloadfile)
          const dataUri = window.URL.createObjectURL(
            new Blob( [csv], { type: "text/csv" } )
          )
          //window.open(dataUri)
          const anchor = document.createElement('a');
          anchor.href = dataUri
          anchor.target = '_blank';
          if(this.ModeModel.code == 1){
            anchor.download = 'DCS' + this.MonthModel.code + this.YearModel + 'Review' + '.csv';
          }
          else {
            anchor.download = 'DCS' + this.MonthModel.code + this.YearModel + 'ver' + this.version + '.csv';
          }
          anchor.click();
        }catch(error) {
          this.$emit('load', false);
          if (!error.response) {
              // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('dcs.dFaildMsg'),"error");
          } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
          console.log(error)
        }
      },

      getCurrentMonth() {
        const cdate = new Date();
        const cmonth = cdate.getMonth() + 1; 
        //const cmonth = 0 + 1;
        let currmonth = {}
        currmonth.code = this.MonthList.find(item => item.code === cmonth).code
        currmonth.name = this.MonthList.find(item => item.code === cmonth).name
        
        return currmonth
      }

    },

    mounted () {     
      this.MonthModel = this.getCurrentMonth()
      this.populateTableNotes()
    },

    created() {
      this.CopyNotesItems = this.itemsNotes;
      this.CopyReviewItems = this.itemsReview;
      
      EventBus.$on("onResetTabList", function (item) {
        this.ActiveTab(item.activeTabNo);
        this.SetTabContent(item.activeTabNo);          
      }.bind(this));

      EventBus.$on("rowNotesClicked", function () {        
        this.SelectedNotesRecords = 0;
        for(var i = 0; i < this.itemsNotes.length; i++){
          if(this.itemsNotes[i].selected){
            this.SelectedNotesRecords++;
          }
        }
      }.bind(this));

      EventBus.$on("rowReviewClicked", function () {        
        this.SelectedReviewRecords = 0;
        for(var i = 0; i < this.itemsReview.length; i++){
          if(this.itemsReview[i].selected){
            this.SelectedReviewRecords++;
          }
        }
      }.bind(this));

      EventBus.$on("rowProductionClicked", function () {        
        this.SelectedProductionRecords = 0;
        for(var i = 0; i < this.itemsProduction.length; i++){
          if(this.itemsProduction[i].selected){
            this.SelectedProductionRecords++;
          }
        }
      }.bind(this));
    }
  };
  </script>

  
<style scoped>

.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img{
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.no-image {
  text-align: center;
  font-size: 18px;
  color: #ffffff;
}

.carouselPic{
    background-color: #FFF !important;
    border-radius: 15px 15px 0 0;
    border: 4px solid #19BEE1;
    overflow: hidden;
}
.carouselPic .carousel-item{
    background-color: #FFF !important;
}
.patPhoto .carousel-description{
    color: white !important;
    background-color: #19BEE1;
    border-radius: 0 0 15px 15px;
    height: 40px;
}
.patPhoto .carousel-description p{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 1;
    font-size: small;
    padding: 2px 10px 2px 10px;
}
.relocateIcon{
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed{
    position: absolute;
    top: 5px;
    right: 25px;
}

.medAdminLabel{
    padding: 0 0.8em;
    display: inline-block;
    margin-top: .4em;
    border-radius: 10px;
    font-variant-caps: all-small-caps;
    vertical-align: top !important;
    font-kerning: 5em;
    font-weight: bold;
    font-size: 0.8em;
    color: #FFF;
}
.allergicToMed{
    background-color: #F00;
    color: #FF9;
    animation: blinking 1s linear infinite;
}
.overdue{
    background-color: var(--overdue);
}
.close-to-admin{
    background-color: var(--close-to-admin);
}
.prior-to-admin{
    background-color: var(--prior-to-admin);
}
.no-pending{
    background-color: var(--no-pending);
}

@keyframes blinking {
    0%, 50% {
        color: #FF9;
    }
    100% {
        color: #F00;
    }
}
@keyframes fadingNow {
    0%, 50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.withDot::after{
    content: "●";
    color: #F00;
    position: absolute;
    top: 4px;
    left: 14px;
    animation: fadingNow 1s infinite;
}
.greenBTN{
    background-color: #0C0 !important;
    border-radius: 15px 0 0 15px !important;
    color: #6F6 !important;
}
.greenBTN:hover{
    background-color: #0F0 !important;
    box-shadow: 0 0 5px #008300;
    color: #FFF !important;
    transform: scale(1.1);
}
.redBTN{
    background-color: #C00 !important;
    border-radius: 0 15px 15px 0 !important;
    color: #F66 !important;
}
.redBTN:hover{
    background-color: #F00 !important;
    box-shadow: 0 0 5px #820000;
    color: #FFF !important;
    transform: scale(1.1);
}

/* MODAL REMAKE */
.zebraAccordion{
    margin: 0 1em;
}
.resetFontSize small{
    font-size: .95em;
}
.zebraAccordion .zebraRow .zebraItem{
    border-radius: 4px 4px 0 0;
    padding: 5px;
    width: 100%;
    cursor: pointer;
    transition: all .3s ease-in-out;
}

.zebraAccordion .zebraRow:nth-child(odd) .zebraItem{
    background-color: #d4f7ff;
}
.zebraAccordion .zebraRow:nth-child(even) .zebraItem{
    background-color: #ecfcff;
}

.zebraAccordion .zebraRow .accordion .zebraItem.not-collapsed {
    background-color: #19BEE1;
    color: #FFF;
}
.zebraAccordion .zebraRow .accordion .zebraItem:hover {
    background-color: #64d6f0;
    color: #FFF;
}
.zItemIcon{
    width: 15%;
    margin: 0 1%;
    display: inline;
    vertical-align: middle;
}

.zItemText{
    width: 86%;
    display: inline;
    vertical-align: middle;
}
@media (max-width: 992px) {
    .zItemIcon{
        width: 10%;
    }
    .zItemText{
        width: 75%;
    }
}
.quickSave{
    color: #19BEE1;
    transition: all .3s ease-in-out;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.quickSave:hover{
    color: #FFF;
}
.zebraAccordion .zebraRow .zebraItem small{
    font-size: .7em;
}
.PRNlabel{
    background-color: #6F6;
    border-radius: 10px;
    padding: 0 10px;
    color: #060 !important;
    transition: all .3s ease-in-out;
}
.PRNlabel:hover{
    background-color: #FF9;
}
.opAT{
    opacity: .5;
}
.accordionContent{
    border-top: 0;
    background: linear-gradient(173deg, #D9F4FB, #FFF 30% );
    padding-top: 3em;
}

.giveMeds button{
    border: 4px solid #FFFFFFEE;
    transition: all .3s ease-in-out;
    cursor: pointer;
}
.redMed{
    border-radius: 0 50px 50px 0;
    border-left: 0;
    background-color: #660000;
    background: linear-gradient(-40deg, #FF0000, #660000);
    animation: spreadShadowLast 1s ease-in-out infinite;
}
.redMed:hover{
    background-color: #FF0000;
    background: linear-gradient(-40deg, #990000, #FF0000);
}
.redMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.greenMed{
    border-radius: 50px 0 0 50px;   
    background-color: #008236;
    background: linear-gradient(-40deg, #008236, #003300);
    border-right: 0 !important;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.greenMed i::before{
    font-size: 1.1em;
}
.greenMed:hover{
    background-color: #00CC00;
    background: linear-gradient(-40deg, #006600,#01d85b);
}
.greenMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.GivNeutral{
    opacity: 0.2;
}

.undoMedLeft{
    background-color: #666;
    background: linear-gradient(-40deg, #EEE, #CCC);
    border: 4px solid #EEE !important;
    border-right: 0 !important;
}
.undoMedLeft:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #999, #CCC);
}
.undoMedRight{
    background-color: #666;
    background: linear-gradient(-40deg, #CCC, #EEE);
    border: 4px solid #EEE !important;
    border-left: 0 !important;
}
.undoMedRight:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #CCC, #999);
}
@keyframes spreadShadow {
    0%, 100% {
        text-shadow: 0 0 1px #00000099;
    }
    50% {
        text-shadow: 0 0 20px #000000FF;
    }
}
@keyframes spreadShadowFirst {
    0%, 100% {
        text-shadow: 0 0 1px #FFFFFF;
    }
    50% {
        text-shadow: 0 0 20px #FFFFFF;
    }
}
@keyframes spreadShadowLast {
    0%, 100% {
        text-shadow: 0 0 20px #FFFFFF, 0 0 20px #FFFFFF;
    }
    25% {
        text-shadow: 0 0 1px #FFFFFF, 0 0 1px #FFFFFF;
    }
}
.justSTAT{
    color: #FFF;
    background-color: #bcd9e0;
    border-radius: 10px;
    padding: 0 5px;
}
.blinkingSTAT{
    color: #FF0;
    background-color: #C00;
    border-radius: 10px;
    padding: 0 5px;
    animation: blinkSTAT 1s steps(5, start) infinite;
}

@keyframes blinkSTAT {
to {
    visibility: hidden;
    }
}

</style>